"use client";

import Link from "next/link";
import Image from "next/image";
import { useComponentTranslations, useI18n } from "@/app/components/LanguageProvider";

export default function WorkClient() {
    const { t } = useComponentTranslations("WorkSection");
    const { lang } = useI18n();
    const locale = lang.startsWith("en") ? "en" : "ru";

    const cases = [
        {
            slug: "neo-bank",
            title: t("caseNeoBankTitle", "Платформа нео-банка"),
            description: t("caseNeoBankDesc", "Безопасная платформа цифрового банкинга с транзакциями в реальном времени, аналитической панелью и многофакторной аутентификацией."),
            image: "/images/case-neobank.webp",
            tags: ["FinTech", "AI", "Mobile"],
        },
        {
            slug: "med-platform",
            title: t("caseMedPlatformTitle", "Медицинская платформа"),
            description: t("caseMedPlatformDesc", "Решение для телемедицины с записью на приём, управлением медицинскими картами пациентов и видеоконсультациями."),
            image: "/images/case-medplatform.webp",
            tags: ["HealthTech", "Web", "API"],
        },
        {
            slug: "ecom-accelerator",
            title: t("caseEcomAcceleratorTitle", "E-Commerce акселератор"),
            description: t("caseEcomAcceleratorDesc", "Высокопроизводительная платформа электронной коммерции с AI-рекомендациями и автоматизированным управлением запасами."),
            image: "/images/case-ecommerce.webp",
            tags: ["E-commerce", "AI", "Analytics"],
        },
    ];

    return (
        <div className="mx-auto max-w-7xl px-4 py-12 md:py-24">
            <div className="text-center mb-12">
                <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
                    {t("sectionWork", "Примеры работ")}
                </h1>
                <p className="text-white/70 max-w-2xl mx-auto">
                    {locale === "ru"
                        ? "Наши проекты охватывают финансы, здравоохранение и e-commerce. Каждый кейс включает задачу, решение и измеримый результат."
                        : "Our projects span finance, healthcare and e-commerce. Each case study includes the challenge, solution and measurable results."}
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                {cases.map((item) => (
                    <Link
                        key={item.slug}
                        href={`/${locale}/work/${item.slug}`}
                        className="group block"
                    >
                        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]">
                            <div className="relative aspect-video overflow-hidden">
                                <Image
                                    src={item.image}
                                    alt={item.title}
                                    fill
                                    sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                                    className="object-cover transition-transform duration-500 group-hover:scale-105"
                                />
                            </div>
                            <div className="p-5">
                                <h3 className="text-xl font-semibold text-white mb-2 group-hover:text-blue-400 transition-colors">
                                    {item.title}
                                </h3>
                                <p className="text-gray-300 text-sm mb-4 line-clamp-3">
                                    {item.description}
                                </p>
                                <div className="flex flex-wrap gap-2 mb-4">
                                    {item.tags.map((tag) => (
                                        <span
                                            key={tag}
                                            className="inline-block px-2.5 py-0.5 bg-blue-500/20 text-blue-300 rounded-full text-xs"
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                                <span className="text-blue-300 text-sm font-medium">
                                    {t("caseButton", "Подробнее")} →
                                </span>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}